export const setUnsavedStatus = (state) => {
  state.hasUnsaveChanges = true;
};
